// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__vNJ_a","subheader":"ReorderModal_subheader__ySrVh","listWrap":"ReorderModal_listWrap__1Xth9"};